import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { convertStringToElements } from "@vds/html-parsers";

import StyledLink from "common-components/StyledLink";
import Button from "common-components/Buttons";
import Header from "common-components/Header";

const AuthorizedAgentExpired = ({
  pageContent: { section_title, section_description, buttons },
  renderAgentTable,
  assignNewAgentClick
}) => {
  return (
    <Fragment>
      <Header style={{ marginBottom: "24px" }}>{convertStringToElements(section_title)}</Header>
      <p style={{ marginBottom: "57px" }}>{section_description}</p>
      {renderAgentTable()}
      <div>
        <StyledLink to="/privacy/secure/your-data" background={buttons[0].type}>
          {buttons[0].text}
        </StyledLink>
        <Button onClick={assignNewAgentClick} background={buttons[1].type}>
          {buttons[1].text}
        </Button>
      </div>
    </Fragment>
  );
};

AuthorizedAgentExpired.propTypes = {
  pageContent: PropTypes.shape({
    section_title: PropTypes.string,
    section_description: PropTypes.string,
    buttons: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string,
        text: PropTypes.text
      })
    )
  }),
  renderAgentTable: PropTypes.func,
  assignNewAgentClick: PropTypes.func
};

export { AuthorizedAgentExpired };
